import React from 'react';
import styled from 'styled-components';

import {
  getStatusColor,
  getStatusTextColor,
  oldGetStatusLabel,
} from '~utils/status.utils';

const TaskStatusLabel = ({ status }) => (
  <Container>
    <Inner bg={getStatusColor(status)} color={getStatusTextColor(status)}>
      {oldGetStatusLabel(status)}
    </Inner>
    <VerticalLine />
  </Container>
);

const Container = styled.div`
  display: flex;
`;

const Inner = styled.span`
  background-color: ${props => props.bg};
  color: ${props => props.color || 'white'};
  // color: black;
  font-size: 12px;
  margin-left: 16px;
  padding: 4px 10px;
`;

const VerticalLine = styled.div`
  background-color: #707070;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 8px;
  width: 1px;
  border-radius: 1px;
`;
export default TaskStatusLabel;
